import class_obj_illus from "../../../../src/sv/images/class_object_illustration.svg";
import class_inherit_illus from "../../../../src/sv/images/class_inheritance_illustration.svg";
import encapsulation_illus from "../../../../src/sv/images/encapsulation_illustration.svg";
import * as React from 'react';
export default {
  class_obj_illus,
  class_inherit_illus,
  encapsulation_illus,
  React
};